export default "__VITE_ASSET__4d4d1449__"